module.exports = __webpack_public_path__ + "img/background_c4-2-1_mobile.6eb6481c.jpg";